import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

import { API_URL, LOCATION_ID } from "..";

const AddBillLayer = () => {
  const [stockOptions, setStockOptions] = useState([]);

  const [suppliers, setSuppliers] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [items, setItems] = useState([{ item_name: "", quantity: "1", rate: "", sellprice:"", amount: "" }]);
  const [expenses, setExpenses] = useState([{ expense_name: "", expense_amount: "" }]);
  const [message, setMessage] = useState({ status: false, reason: "", desc: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef(null);

    const today = new Date().toISOString().split("T")[0];

  // ✅ Fetch suppliers for dropdown

    const [poNumber, setPoNumber] = useState();
    

     useEffect(()=>{
       const locationId = localStorage.getItem('locationID')
    const fetchNextNumber = async () =>{
      const nextPO = await fetch(`${API_URL}/api/purchase-orders/po/next-bill-number?locationId=${locationId}`)
  .then(r => r.json());

setPoNumber(nextPO.nextBillNumber);
    }

    fetchNextNumber()
      
  },[])
  useEffect(() => {
     const locationId = localStorage.getItem('locationID')
    fetch(`${API_URL}/api/suppliers?locationId=${locationId}`)
      .then((res) => res.json())
      .then((data) => {
        const formatted = data?.suppliers.map((s) => ({ label: s.name, value: s.id }));
        setSuppliers(formatted);
      })
      .catch(() => {
        setMessage({ status: true, reason: "error", desc: "Failed to load suppliers" });
      });
  }, []);

  useEffect(() => {
  fetch(`${API_URL}/api/invoice/stock/fetch?locationId=${LOCATION_ID}`)
    .then(res => res.json())
    .then(data => {
      const formatted = data?.stock?.map(s => ({
        label: s.title,
        value: s.title,
        rate: s.costPrice,
        sellPrice: s.sellPrice
      }));
      setStockOptions(formatted);
    });
}, []);



  // ✅ ITEM handlers
  const handleItemChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;

    if (field === "quantity" || field === "rate") {
      const qty = parseFloat(updated[index].quantity || 0);
      const rate = parseFloat(updated[index].rate || 0);
      updated[index].amount = (qty * rate).toFixed(2);
    }
    setItems(updated);
  };
  const addItemRow = () => setItems([...items, { item_name: "", quantity: "", rate: "", sellprice:"", amount: "" }]);
  const removeItemRow = (index) => setItems(items.filter((_, i) => i !== index));

  // ✅ EXPENSE handlers
  const handleExpenseChange = (index, field, value) => {
    const updated = [...expenses];
    updated[index][field] = value;
    setExpenses(updated);
  };
  const addExpenseRow = () => setExpenses([...expenses, { expense_name: "", expense_amount: "" }]);
  const removeExpenseRow = (index) => setExpenses(expenses.filter((_, i) => i !== index));

  // ✅ SUBMIT Bill
  const submitBill = async (e, shouldPrint = false) => {
  e.preventDefault();
  setMessage({ status: false, reason: "", desc: "" });

  const form = formRef.current;
  const formData = {
    supplier_id: selectedSupplier?.value,
    bill_number: form.bill_number.value,
    date: form.date.value,
    location_id: LOCATION_ID,
    items,
    expenses,
  };

  if (!formData.supplier_id) {
    return setMessage({ status: true, reason: "error", desc: "Supplier is required" });
  }
  if (!formData.bill_number) {
    return setMessage({ status: true, reason: "error", desc: "Bill number is required" });
  }

  setIsSubmitting(true);

  try {
    const res = await fetch(`${API_URL}/api/purchase-bills`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const data = await res.json();

    if (!res.ok) {
      // ❌ API failed: DO NOT print, DO NOT navigate
      throw new Error(data.message || "Failed to add bill");
    }

    // ✔ Success
    setMessage({ status: true, reason: "success", desc: "Bill added successfully" });

    const billId = data?.bill?.id || data?.id;

    // -----------------------------
    // 🔥 Submit & Print
    // -----------------------------
    if (shouldPrint) {
      if (!billId) {
        setMessage({ status: true, reason: "error", desc: "Could not generate bill for printing" });
        return;
      }

      const printWindow = window.open(`/print-bill/${billId}`, "_blank");
      if (printWindow) printWindow.focus();
      return; // ❗ stop; do not redirect
    }

    // -----------------------------
    // 🔥 Submit & Close
    // -----------------------------
    form.reset();
    setSelectedSupplier(null);
    setItems([{ item_name: "", quantity: "1", rate: "", sellprice: "", amount: "" }]);
    setExpenses([{ expense_name: "", expense_amount: "" }]);

    window.location.href = "/list-bills";

  } catch (err) {
    setMessage({ status: true, reason: "error", desc: err.message });
  } finally {
    setIsSubmitting(false);
  }
};


  // ✅ Total calculation (items + expenses)
  const totalItems = items.reduce((sum, i) => sum + Number(i.amount || 0), 0);
  const totalExpenses = expenses.reduce((sum, e) => sum + Number(e.expense_amount || 0), 0);
  const grandTotal = totalItems + totalExpenses;

  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-body p-24">
        <div className="row justify-content-center">
          <div className="col-xxl-8 col-xl-10 col-lg-10">
            <div className="card border">
              <div className="card-body">
                {message.status && (
                  <div
                    className={`alert alert-${message.reason === "error" ? "danger" : "success"} alert-dismissible fade show mb-20`}
                    role="alert"
                  >
                    {message.desc}
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setMessage({ ...message, status: false })}
                      aria-label="Close"
                    ></button>
                  </div>
                )}

                <form ref={formRef} onSubmit={(e) => submitBill(e, false)}>
                  {/* Supplier */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Supplier <span className="text-danger-600">*</span>
                    </label>
                    <Select
                      options={suppliers}
                      placeholder="Select Supplier"
                      value={selectedSupplier}
                      onChange={setSelectedSupplier}
                      classNamePrefix="select"
                    />
                  </div>

                  {/* Bill Number */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Bill Number <span className="text-danger-600">*</span>
                    </label>
                    <input type="text" className="form-control radius-8" id="bill_number" value={poNumber} name="bill_number" />
                  </div>

                  {/* Bill Date */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Bill Date <span className="text-danger-600">*</span>
                    </label>
                    <input type="date" className="form-control radius-8" id="date"  defaultValue={today}  name="date" />
                  </div>

                  {/* Items Table */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">Items</label>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Item Name</th>
                          <th>Qty</th>
                          <th>Rate</th>
                          <th>Sell Price</th>
                          <th>Amount</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.map((item, idx) => (
                          <tr key={idx}>
                            <td style={{ minWidth: "250px" }}>
                         <CreatableSelect 
  value={item.item_name ? { label: item.item_name, value: item.item_name } : null}
  options={stockOptions}
  placeholder="Select or type item..."
  onChange={(opt) => {
    const selected = opt ? opt.value : "";
    handleItemChange(idx, "item_name", selected);

    // Auto-fill rate & sell price if item exists
    const stock = stockOptions.find(s => s.value === selected);
    if (stock) {
      handleItemChange(idx, "rate", stock.rate);
      handleItemChange(idx, "sellprice", stock.sellPrice);
    }
  }}
  onCreateOption={(newItemName) => {
    // When user enters new item name
    handleItemChange(idx, "item_name", newItemName);
  }}
/></td>

                            <td>
                              <input
                                type="number"
                                className="form-control"
                                value={item.quantity}
                                onChange={(e) => handleItemChange(idx, "quantity", e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                value={item.rate}
                                onChange={(e) => handleItemChange(idx, "rate", e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                value={item.sellprice}
                                onChange={(e) => handleItemChange(idx, "sellprice", e.target.value)}
                              />
                            </td>
                            <td>
                              <input type="number" className="form-control" value={item.amount} readOnly />
                            </td>
                            <td>
                              {items.length > 1 && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() => removeItemRow(idx)}
                                >
                                  Remove
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <button type="button" className="btn btn-outline-primary mt-2" onClick={addItemRow}>
                      + Add Item
                    </button>
                  </div>

                  {/* Expenses Table */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">Additional Expenses</label>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Expense Name</th>
                          <th>Amount</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {expenses.map((exp, idx) => (
                          <tr key={idx}>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={exp.expense_name}
                                onChange={(e) => handleExpenseChange(idx, "expense_name", e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                value={exp.expense_amount}
                                onChange={(e) => handleExpenseChange(idx, "expense_amount", e.target.value)}
                              />
                            </td>
                            <td>
                              {expenses.length > 1 && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() => removeExpenseRow(idx)}
                                >
                                  Remove
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <button type="button" className="btn btn-outline-primary mt-2" onClick={addExpenseRow}>
                      + Add Expense
                    </button>
                  </div>

                  {/* Totals */}
                  <div className="text-end mb-3">
                    <h6>Item Total: Rs. {totalItems.toLocaleString()}</h6>
                    <h6>Expense Total: Rs. {totalExpenses.toLocaleString()}</h6>
                    <h5 className="fw-bold">Grand Total: Rs. {grandTotal.toLocaleString()}</h5>
                  </div>

                  {/* Buttons */}
                  <div className="d-flex justify-content-center gap-3">
                    <button type="submit" className="btn btn-primary px-56 py-12 radius-8" disabled={isSubmitting}>
                      {isSubmitting ? "Submitting..." : "Submit & Close"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-success px-56 py-12 radius-8"
                      disabled={isSubmitting}
                      onClick={(e) => submitBill(e, true)}
                    >
                      {isSubmitting ? "Processing..." : "Submit & Print"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBillLayer;
